import React, { useRef } from 'react'

// UI

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from '@chakra-ui/react'

import { toast } from 'react-toastify'

// Custom

import { camelToWords } from '@/utils/stringHelper'
import { useApplication } from '../../useApplication'

const ApplicationApprovalModal = ({ modalDetail, setModalDetail }) => {
  const { show, type, id } = modalDetail

  const { useApproveApplication, useRejectApplication } = useApplication()
  const approveApplication = useApproveApplication()
  const rejectApplication = useRejectApplication()

  const remark = useRef()

  const closeModal = () => {
    setModalDetail({
      show: false,
      type: '',
      detail: {},
    })
  }

  const onSubmit = (e) => {
    e.preventDefault()

    const remarkValue = remark.current.value
    const payload = {
      id: id,
      remark: remarkValue,
    }

    switch (type) {
      case 'approve':
        approveApplication.mutate(payload, {
          onSuccess: () => {
            closeModal()
          },
        })
        break

      case 'reject':
        rejectApplication.mutate(payload, {
          onSuccess: () => {
            closeModal()
          },
        })
        break

      default:
        toast.error('Unknown Modal Type ! ')
        break
    }
  }

  return (
    <Modal isOpen={show} onClose={closeModal} size="xl">
      <form onSubmit={onSubmit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{camelToWords(type)} Application</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>Reason: </p>
            <Textarea cname="remark" rows="5" ref={remark} />
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button colorScheme={['reject'].includes(type) ? 'red' : 'green'} type="submit">
                {camelToWords(type)}
              </Button>
              <Button colorScheme="gray" onClick={closeModal}>
                Close
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  )
}

export default ApplicationApprovalModal
